import { extends as _extends, objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useMemo } from 'react';
import { positions } from '../../../utils/props-utils.esm.js';
import { createUseStyledComponent } from '../../../hooks/use-styled-component.esm.js';

var _excluded = ["as", "inline", "__css"];
var useStyledComponent = createUseStyledComponent(['div', 'span'], 'csg-box');
var BoxPrivate = /*#__PURE__*/React.forwardRef(function BoxPrivate(props, ref) {
  var _props$as = props.as,
    component = _props$as === void 0 ? 'div' : _props$as,
    inline = props.inline,
    __css = props.__css,
    rest = _objectWithoutProperties(props, _excluded);
  var Component = useStyledComponent(component);
  var baseStyles = useMemo(function () {
    return _objectSpread2(_objectSpread2(_objectSpread2({}, inline ? {
      display: 'inline-block'
    } : {}), positions(props)), __css);
  }, [__css, inline, props]);
  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref
  }, rest, {
    __css: baseStyles
  }));
});
var Box = /*#__PURE__*/React.forwardRef(function Box(props, ref) {
  return /*#__PURE__*/React.createElement(BoxPrivate, _extends({
    ref: ref
  }, props));
});

export default Box;
export { BoxPrivate };
//# sourceMappingURL=box.esm.js.map
